/* ============================================================
   コーデギャラリー (UGC) v4 — carousel + lightbox (dependency-free)
   ------------------------------------------------------------
   v4 の追加:
     - ライトボックス内を複数画像カルーセル化(メイン + サムネ列 + 送り + ←→キー)
     - 動画コマは ▶ を出し、押すと Instagram 埋め込みに差し替えて再生
     - キャプション表示 +「続きを読む」折りたたみ

   注意: Instagram の埋め込みURLは permalink から JS 側で組み立てる。
        Liquid の文字列フィルタに URL 型を通すと空になるため。
   ============================================================ */
(function () {
  function initBlock(root) {
    if (root.dataset.igugcInit) return;
    root.dataset.igugcInit = '1';

    var track = root.querySelector('.ig-ugc__track');

    // --- グリッド/横スクロールの矢印 ---
    root.querySelectorAll('.ig-ugc__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        var tile = track.querySelector('.ig-ugc__tile');
        var step = tile ? (tile.getBoundingClientRect().width + 16) : 300;
        track.scrollBy({ left: step * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
      });
    });

    // --- ライトボックス ---
    var lb = root.querySelector('.ig-ugc__lightbox');
    if (!lb) return;

    var lbImgWrap = lb.querySelector('.ig-ugc__lb-image');
    var lbImg     = lb.querySelector('.ig-ugc__lb-image img');
    var lbVideo   = lb.querySelector('.ig-ugc__lb-video');
    var lbPlay    = lb.querySelector('.ig-ugc__lb-playbtn');
    var lbThumbs  = lb.querySelector('.ig-ugc__lb-thumbs');
    var lbCount   = lb.querySelector('.ig-ugc__lb-count');
    var lbItems   = lb.querySelector('.ig-ugc__lb-items');
    var lbIg      = lb.querySelector('.ig-ugc__lb-ig');
    var lbCap     = lb.querySelector('.ig-ugc__lb-caption');
    var lbCapText = lb.querySelector('.ig-ugc__lb-caption-text');
    var lbMore    = lb.querySelector('.ig-ugc__lb-more');
    var navs      = lb.querySelectorAll('.ig-ugc__lb-nav');
    var clickMode = root.dataset.click || 'lightbox';

    var slides = [];       // [{full, thumb, video}]
    var index = 0;
    var permalink = '';

    function buildEmbed(url) {
      if (!url || url.indexOf('instagram.com') === -1) return '';
      // クエリを除去し末尾スラッシュを整えて /embed/ を付与
      var base = url.split('?')[0].replace(/\/+$/, '');
      return base + '/embed/';
    }

    function showEmbed() {
      var embed = buildEmbed(permalink);
      if (embed.indexOf('instagram.com') === -1) return false;
      lbVideo.innerHTML = '<iframe src="' + embed + '" loading="lazy" allowtransparency="true" allowfullscreen="true" frameborder="0" scrolling="no"></iframe>';
      lbVideo.hidden = false;
      if (lbImgWrap) lbImgWrap.hidden = true;
      if (lbPlay) lbPlay.hidden = true;
      return true;
    }

    function clearEmbed() {
      if (lbVideo) { lbVideo.innerHTML = ''; lbVideo.hidden = true; }
      if (lbImgWrap) lbImgWrap.hidden = false;
    }

    function renderSlide(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      var s = slides[index];

      clearEmbed();
      if (lbImg) lbImg.src = s.full || '';
      // 動画コマ: ▶ を出す(押すと埋め込み再生)
      if (lbPlay) lbPlay.hidden = !s.video;

      if (lbCount) {
        if (slides.length > 1) {
          lbCount.textContent = (index + 1) + ' / ' + slides.length;
          lbCount.hidden = false;
        } else {
          lbCount.hidden = true;
        }
      }
      lbThumbs.querySelectorAll('.ig-ugc__lb-thumb').forEach(function (t, ti) {
        t.classList.toggle('is-active', ti === index);
        if (ti === index && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    }

    function buildThumbs() {
      lbThumbs.innerHTML = '';
      if (slides.length < 2) { lbThumbs.hidden = true; return; }
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ig-ugc__lb-thumb' + (s.video ? ' is-video' : '');
        b.setAttribute('aria-label', (i + 1) + '枚目');
        b.innerHTML = '<img src="' + s.thumb + '" alt="" loading="lazy">' +
          (s.video ? '<span class="ig-ugc__lb-thumb-play" aria-hidden="true"><svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M8 5v14l11-7z"/></svg></span>' : '');
        b.addEventListener('click', function () { renderSlide(i); });
        lbThumbs.appendChild(b);
      });
      lbThumbs.hidden = false;
    }

    function setupCaption(tile) {
      var data = tile.querySelector('.ig-ugc__caption-data');
      var text = data ? data.textContent.trim() : '';
      if (!lbCap) return;
      if (!text) { lbCap.hidden = true; return; }
      lbCapText.textContent = text;
      lbCapText.classList.add('is-clamped');
      lbCap.hidden = false;
      if (lbMore) {
        lbMore.textContent = '続きを読む';
        lbMore.hidden = true;
        // クランプで実際に溢れているときだけ「続きを読む」を出す
        requestAnimationFrame(function () {
          if (lbCapText.scrollHeight > lbCapText.clientHeight + 2) lbMore.hidden = false;
        });
      }
    }

    function openLB(tile) {
      permalink = tile.dataset.permalink || '';

      // スライド配列を組み立て
      slides = [];
      tile.querySelectorAll('.ig-ugc__slide').forEach(function (el) {
        slides.push({
          full: el.dataset.full || '',
          thumb: el.dataset.thumb || '',
          video: el.dataset.video === '1'
        });
      });
      // images が無い投稿は従来どおり1枚扱い
      if (!slides.length) {
        slides = [{ full: tile.dataset.full || '', thumb: tile.dataset.full || '', video: tile.dataset.video === '1' }];
      }

      buildThumbs();
      navs.forEach(function (n) { n.hidden = slides.length < 2; });
      renderSlide(0);

      // 投稿まるごと動画(is_video)なら開いた時点で埋め込み再生
      if (tile.dataset.video === '1' && slides.length === 1) showEmbed();

      var data = tile.querySelector('.ig-ugc__items-data');
      if (lbItems) lbItems.innerHTML = data ? data.innerHTML : '';

      setupCaption(tile);

      if (lbIg) {
        if (permalink) { lbIg.href = permalink; lbIg.hidden = false; }
        else { lbIg.hidden = true; }
      }
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeLB() {
      lb.hidden = true;
      clearEmbed();            // 再生を止めるため埋め込みを破棄
      if (lbPlay) lbPlay.hidden = true;
      document.documentElement.style.overflow = '';
    }

    // タイル → ライトボックス
    root.querySelectorAll('.ig-ugc__tile').forEach(function (tile) {
      function activate() {
        // 動画・複数画像は常にライトボックスで開く
        var multi = tile.dataset.slides && parseInt(tile.dataset.slides, 10) > 1;
        if (clickMode === 'product' && tile.dataset.video !== '1' && !multi) {
          var links = tile.querySelectorAll('.ig-ugc__items-data a');
          if (links.length === 1) { window.location.href = links[0].href; return; }
        }
        openLB(tile);
      }
      tile.addEventListener('click', activate);
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });

    // 送り
    navs.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        renderSlide(index + parseInt(btn.dataset.slide, 10));
      });
    });

    // 動画コマの再生
    if (lbPlay) {
      lbPlay.addEventListener('click', function (e) { e.stopPropagation(); showEmbed(); });
    }

    // 続きを読む
    if (lbMore) {
      lbMore.addEventListener('click', function () {
        var clamped = lbCapText.classList.toggle('is-clamped');
        lbMore.textContent = clamped ? '続きを読む' : '閉じる';
      });
    }

    lb.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', closeLB);
    });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLB();
      else if (e.key === 'ArrowLeft' && slides.length > 1) renderSlide(index - 1);
      else if (e.key === 'ArrowRight' && slides.length > 1) renderSlide(index + 1);
    });

    // スワイプ(スマホ)
    var tx = null;
    var stage = lb.querySelector('.ig-ugc__lb-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (tx === null || slides.length < 2) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) renderSlide(index + (dx < 0 ? 1 : -1));
        tx = null;
      }, { passive: true });
    }
  }

  function initAll() { document.querySelectorAll('.ig-ugc').forEach(initBlock); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // テーマエディタで再描画されたときにも対応
  document.addEventListener('shopify:section:load', initAll);
})();
